export default {
  props: ['badge'],
  
  data() {
    return {
      open: false,
    };
  },

  methods: {
    onToggleOpen() {
      this.open = !this.open;
    },

    clickout(event) {
      if (!this.$refs.container) return;
      if (!this.$refs.container.contains(event.target)) {
        this.open = false;
      }
    }
  },

  mounted() {
    document.body.addEventListener("click", this.clickout);
  },

  beforeDestroy() {
    document.body.removeEventListener("click", this.clickout);
  },
};
